import { atom } from 'recoil';
import defaultProject from 'ProjectManager/Project/Common/recoil/project/defaultProject';

const projectAtom = atom({
    key: 'projectManager_projectDataManagement',
    default: defaultProject,
});

export default projectAtom;
